import { IMaterial } from '../../../__core/Interfaces/IMaterial';
import MATERIAL_TYPES from '../../../__core/Enums/MaterialTypes';

export default class MaterialFileNameBuilder {
  private _material: IMaterial;

  constructor(material: IMaterial) {
    this._material = material;
  }

  private _getNameWithUnderscores(): string {
    return this._material.name.split(' ').join('_');
  }

  private _getPresentationFileName(): string {
    const extension = '.pdf';

    return this._getNameWithUnderscores() + extension;
  }

  private _getAttachmentFileName(): string {
    const materialOrderNumber = this._material.sourceName.split('.');

    if (materialOrderNumber.length > 2) {
      const extension = materialOrderNumber.pop();

      return `${this._getNameWithUnderscores()}.${extension}`;
    }

    return this._material.sourceName;
  }

  public getFileNameName(): string {
    switch (this._material.type) {
      case MATERIAL_TYPES.PRESENTATION_PDF:
      case MATERIAL_TYPES.PRESENTATION_REVEAL:
        return this._getPresentationFileName();

      case MATERIAL_TYPES.ATTACHMENT:
        return this._getAttachmentFileName();

      default:
        return this._material.sourceName;
    }
  }
}
